<template>
  <li
    class="c-category-menu__item"
    :class="{
      'is-selected': isSelected,
      'has-children': hasChildren
    }"
  >
    <a
      class="c-category-menu__link"
      :href="path"
      :data-testid="`button-bar-category-${slug}`"
      @click="onClick"
    >
      {{ name }}

      <vIcon
        v-if="hasChildren"
        name="arrow-right"
        color="primary"
        size="medium"
      />
    </a>
  </li>
</template>

<script>
  import vIcon from '@/web/components/icon.vue'

  export default {
    name: 'CategoryMenuItem',
    components: {
      vIcon
    },
    props: {
      name: {
        type: String,
        required: true
      },
      slug: {
        type: String,
        required: true
      },
      path: {
        type: String,
        required: true
      },
      hasChildren: {
        type: Boolean,
        default: false
      },
      isSelected: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onClick(event) {
        if (this.hasChildren) {
          event.preventDefault()
          this.$emit('select', this.slug)
        } else {
          window.location.assign(this.path)
        }
      }
    }
  }
</script>
